export default __webpack_public_path__ + "static/media/my-image-2.dfa6fdf9.png";